import { FC } from 'react';

import { ButtonGroup } from 'reactstrap';

import { ActionItem, ActionLabel, ActionsDropdown, FontAwesomeIcon, IconButton } from '@hsp/react-component-library';

import { SaveAndCloseButtonProps } from 'types/pages/audience-builder/shared/save';
import { s } from 'utilities/strings';

import { useSaveCloseButtonConfiguration } from './hooks';

import cssClasses from './save-close-button.module.scss';

const SaveCloseButton: FC<SaveAndCloseButtonProps> = ({ allowRun = true, onClose, ...props }) => {
  const { handleReset, handleSave, handleSaveAndRun, isDirty, isDisabled, saveAndCloseLabel, saveLabel } =
    useSaveCloseButtonConfiguration(props);

  return (
    <>
      <ButtonGroup className={cssClasses.saveCloseButton}>
        <IconButton
          color="primary"
          disabled={isDisabled}
          icon={['fas', 'save']}
          onClick={handleSave}>
          {saveLabel}
        </IconButton>
        <ActionsDropdown caret={false}>
          <ActionLabel>
            <FontAwesomeIcon icon={['fas', 'ellipsis-vertical']} />
          </ActionLabel>
          <ActionItem
            action="saveAndClose"
            condition={allowRun}
            disabled={isDisabled}
            icon={['fas', 'save']}
            label={saveAndCloseLabel}
            onSelected={handleSaveAndRun}
          />
          <ActionItem
            action="reset"
            disabled={!isDirty}
            icon={['fas', 'rotate']}
            label={s('Site.Reset')}
            onSelected={handleReset}
          />
          <ActionItem
            action="cancel"
            icon={['fas', 'xmark']}
            label={s('Site.Cancel')}
            onSelected={onClose}
          />
        </ActionsDropdown>
      </ButtonGroup>
    </>
  );
};

export default SaveCloseButton;
